import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';

const loaderStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  overflow: hidden;
`;

export const Loader: React.FC<{ styles?: React.CSSProperties }> = ({ styles }) => {
  return (
    <div className={loaderStyle}>
      <LoadingOutlined
        style={{
          ...styles,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          fontSize: '40px',
        }}
      />
    </div>
  );
};
